import {
  BetHistoryFilterTypes,
  BetStatus,
  betStore,
  notificationStore,
  userInfoStore,
  useUserInfoStore,
} from '@pascal/pascal-core';
import { useCallback } from 'react';
import { doBetStore } from '../store';

export const useDemoSwitcher = () => {
  const { playerExternalId } = useUserInfoStore();
  const { liveBets, setLiveBets, setBetHistoryFilter } = betStore;

  const demoSwitcherAdditionalFunction = useCallback(() => {
    const otherBets = liveBets.filter((bet) => bet.playerExternalId);
    betStore.setDemoBetHistory([]);
    userInfoStore.setDemoInitialBalance();
    notificationStore.setNotificationType(null);
    betStore.resetBetHistory();
    doBetStore.resetAutoBet();
    doBetStore.resetGameStates();
    setLiveBets(otherBets);
    setBetHistoryFilter(BetHistoryFilterTypes.All);
    const userCurrentBets = liveBets.filter(
      (item) =>
        item?.playerExternalId === userInfoStore.playerExternalId &&
        !item.winAmount &&
        item.status === BetStatus.Pending
    );
    userCurrentBets.forEach((item) => {
      doBetStore.updateBetAccepted(true, item.id);
    });
  }, [liveBets, playerExternalId]);
  return { demoSwitcherAdditionalFunction };
};
